import AWS from 'aws-sdk'

const S3_Bucket = process.env.REACT_APP_Bucket
const region = 'ap-south-1'

AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWSAccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWSSecretKey
})

export const myBucket = new AWS.S3({
    params: {Bucket: S3_Bucket},
    region: region,
})
